import { ENROLLMENT_STATUS } from 'constants/admin/enrollments';
import { Radio } from 'antd';

const ALL_STATUSES = 'all';

const STATUS_OPTIONS = [
  {
    value: ALL_STATUSES,
    label: 'Todos',
    className:
      '[&.ant-radio-button-wrapper-checked]:!bg-slate-600 [&.ant-radio-button-wrapper-checked]:!border-slate-600 [&.ant-radio-button-wrapper-checked]:!text-white'
  },
  {
    value: ENROLLMENT_STATUS.ACTIVE,
    label: 'Ativo',
    className:
      '[&.ant-radio-button-wrapper-checked]:!bg-green-600 [&.ant-radio-button-wrapper-checked]:!border-green-600 [&.ant-radio-button-wrapper-checked]:!text-white'
  },
  {
    value: ENROLLMENT_STATUS.INACTIVE,
    label: 'Inativo',
    className:
      '[&.ant-radio-button-wrapper-checked]:!bg-orange-500 [&.ant-radio-button-wrapper-checked]:!border-orange-500 [&.ant-radio-button-wrapper-checked]:!text-white'
  },
  {
    value: ENROLLMENT_STATUS.CANCELLED,
    label: 'Cancelado',
    className:
      '[&.ant-radio-button-wrapper-checked]:!bg-red-500 [&.ant-radio-button-wrapper-checked]:!border-red-500 [&.ant-radio-button-wrapper-checked]:!text-white'
  }
];

interface EnrollmentStatusFilterProps {
  value?: string;
  onChange: (status?: string) => void;
}

export const EnrollmentStatusFilter = ({
  value,
  onChange
}: EnrollmentStatusFilterProps) => {
  return (
    <Radio.Group
      buttonStyle="solid"
      value={value ?? ALL_STATUSES}
      onChange={event => {
        const nextValue = event.target.value;
        onChange(nextValue === ALL_STATUSES ? undefined : nextValue);
      }}
    >
      {STATUS_OPTIONS.map(option => (
        <Radio.Button
          key={option.value}
          value={option.value}
          className={option.className}
        >
          {option.label}
        </Radio.Button>
      ))}
    </Radio.Group>
  );
};
